import { render, staticRenderFns } from "./C2wCampaignsSummary.vue?vue&type=template&id=1cbd0888&scoped=true&"
import script from "./C2wCampaignsSummary.vue?vue&type=script&lang=js&"
export * from "./C2wCampaignsSummary.vue?vue&type=script&lang=js&"
import style0 from "./C2wCampaignsSummary.vue?vue&type=style&index=0&id=1cbd0888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbd0888",
  null
  
)

export default component.exports